import { forwardRef } from 'react';

import Icon from '../icon';

import SortInactiveSvgIcon from './sort-inactive.svg?react';

/* This file is autogenerated, see readme.md for instructions */
import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

/**
 * @deprecated This icon has been removed from the @bloomreach/banana-theme package.
 * Please don't use it anymore. It will be removed in the next major version.
 */
const SortInactiveIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <SortInactiveSvgIcon />
    </Icon>
  );
});

SortInactiveIcon.displayName = 'SortInactiveIcon';

export default SortInactiveIcon;
